// Mise à jour du service API WordPress
import axios from 'axios';
import CryptoJS from 'crypto-js';

const WP_API_URL = 'https://senoscar.com/wp-json';
const WP_CONSUMER_KEY = 'ck_dd3acb1cf828113703e66f8bae4d81508abd8202';
const WP_CONSUMER_SECRET = 'cs_906f8371e4c8c4ce675ff11b66dc7e07bd44d023';



// Fonction pour ajouter une image à la médiathèque WordPress
export const uploadImageToWordPress = async (file) => {
  try {
    // Pour l'upload de médias, utiliser l'authentification par JWT ou Basic Auth
    const formData = new FormData();
    formData.append('file', file);
    
    // Utilisez Basic Auth pour l'upload de médias
    const response = await axios.post(`${WP_API_URL}/wp/v2/media`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL3Nlbm9zY2FyLmNvbSIsImlhdCI6MTc0NTgzODY2MCwibmJmIjoxNzQ1ODM4NjYwLCJleHAiOjE3NDY0NDM0NjAsImRhdGEiOnsidXNlciI6eyJpZCI6IjEifX19.eejYBAsVGNaUY8E02y8P9gxzKTjr_zOB8ZNdgmpyX8E' 
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error uploading image to WordPress:', error);
    throw error;
  }
};

// Fonction pour créer un produit dans WordPress (WooCommerce)
export const createWordPressProduct = async (productData, imageIds) => {
  try {
    const endpoint = '/wc/v3/products';
    const url = `${WP_API_URL}${endpoint}?consumer_key=${WP_CONSUMER_KEY}&consumer_secret=${WP_CONSUMER_SECRET}`;
    
    // Préparer les données du produit
    const wpProductData = {
      name: productData.name,
      description: productData.description,
      regular_price: productData.regular_price.toString(),
      sku: productData.sku,
      categories: productData.category ? [{ name: productData.category }] : [],
      images: imageIds.map(id => ({ id })),
      meta_data: [
        { key: 'dimensions', value: productData.dimensions }
      ]
    };

    const response = await axios.post(url, wpProductData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error creating product in WordPress:', error);
    if (error.response) {
      console.error('Response error data:', error.response.data);
    }
    throw error;
  }
};
